import React from 'react';

const NavigationDots = ({ active }) => {
  return (
    <div className='app__navigation'>
      {['home', 'about', 'work', 'skills', 'testimonials', 'contact'].map(
        (item, index) => (
          <a
            key={item + index}
            href={`#${item}`}
            style={
              active === item
                ? { backgroundColor: '#313BAC', borderRadius: '5px' }
                : {}
            }
          >
            <div className='app__navigation-dot' />
          </a>
        )
      )}
    </div>
  );
};

export default NavigationDots;
